export const DW_AUTO_REFRESH_STORAGE_KEY = 'dwRequestAutoRefresh';
export const BET_VOID_AUTO_REFRESH_STORAGE_KEY = 'betVoidAutoRefresh';
export const VOID_HISTORY_AUTO_REFRESH_STORAGE_KEY = 'voidHistoryAutoRefresh';
